import type { ActiveTenant, AuthUser, Membership } from "../api/types";

export type AuthStatus =
  | "loading"
  | "unauthenticated"
  | "authenticated_without_tenant"
  | "authenticated_with_tenant";

export type AuthSnapshot = {
  status: AuthStatus;
  user: AuthUser | null;
  memberships: Membership[];
  activeTenant: ActiveTenant | null;
};

export function deriveAuthStatus(input: {
  user: AuthUser | null;
  activeTenant: ActiveTenant | null;
}): Exclude<AuthStatus, "loading"> {
  if (!input.user) {
    return "unauthenticated";
  }
  if (input.activeTenant) {
    return "authenticated_with_tenant";
  }
  return "authenticated_without_tenant";
}

export function activeMemberships(memberships: Membership[]): Membership[] {
  return memberships.filter(
    (m) => m.status === "active" && m.tenantStatus === "active",
  );
}

export function postAuthPath(snapshot: AuthSnapshot): string {
  if (snapshot.status === "unauthenticated" || snapshot.status === "loading") {
    return "/login";
  }
  if (snapshot.status === "authenticated_with_tenant") {
    return "/";
  }
  const active = activeMemberships(snapshot.memberships);
  if (active.length === 0) {
    return "/no-access";
  }
  if (active.length === 1) {
    return "/";
  }
  return "/select-tenant";
}
